import React from "react";
import { useParams } from "react-router-dom";
import JobForm from "job/components/JobForm";
import Heading from "common/components/Heading";
import { grey } from "@mui/material/colors";

const EditJob = () => {
  const { jobId } = useParams();
  return (
    <div>
      <div>
        <div>
          <Heading
            variant={"h3"}
            title={"Edit Job"}
            sxProp={{ fontWeight: 800, m: 2, p: 2, color: grey[600] }}
          />
        </div>
        <JobForm jobId={jobId} />
      </div>
    </div>
  );
};

export default EditJob;
